 
import axios from 'axios'
export default {
  data () {
    return {
      landingTestChannelUrl: '',
      channels: []
    }
  },
  mounted () {
    this.getConfig()
  },
  methods: {
    async getConfig () {
      const res = await axios.get(process.env.VUE_APP_STATIC_CONFIG)
      if (res.status === 200 && res.data) {
        const { landingTestChannel, landingTestChannelUrl } = res.data
        this.landingTestChannelUrl = landingTestChannelUrl
        if (landingTestChannel) {
          this.channels = landingTestChannel.split(',')
        }
      }
    }
  }
}